import { IOmniaCommand, IOmniaCommandGroup, IPopupContext, isArrayEmpty, partition } from "../../omnia"

import getIconClass = omnia.getIconClass

interface Executable {
    run: (c: IOmniaCommand) => void
    check: (c: IOmniaCommand) => boolean
}

export const ContextMenu: React.FunctionComponent<{ popup: IPopupContext }> = ({ popup }) => {

    if (!popup) return null

    const groups = popup.context.getPopupCommands(popup.target)
    if (isArrayEmpty(groups)) return null

    const lastGroup = groups[groups.length - 1]
    const [fg, bg] = partition(groups, c => c.foreground)

    return (

        <div
            className={`omnia-fields-timeline-popup tl-popup ${popup.offsetLeft ? 'offset-left' : ''}`}
            style={{ position: "absolute", left: popup.x, top: popup.y }}
            onClick={e => e.preventDefault()}
        >

            <div className={`omnia-popup-menu btn-group open`}>
                <>
                    {
                        fg.map(g => (
                            <ul className="dropdown-menu" key={g.text || g.commands[0].text}>
                                <>
                                    {g.text ? <li className="dropdown-header">{g.text}</li> : null}
                                    <Commands commands={g.foregroundCommands()} exec={getExecutable(g)} />
                                    <Submenu commands={g.backgroundCommands()} exec={getExecutable(g)} />
                                    {(g != lastGroup) ? <li className="divider"></li> : null}
                                </>
                            </ul>
                        ))
                    }
                    <BgGroup group={bg} lastGroup={lastGroup} />
                </>
            </div>

        </div>

    )
}

const BgGroup: React.FunctionComponent<{ group: IOmniaCommandGroup[], lastGroup: IOmniaCommandGroup }> = ({ group, lastGroup }) => {

    group = group.filter(g => !isArrayEmpty(g.commands))
    if (isArrayEmpty(group)) return null

    group.map(g => (
        <ul className="dropdown-menu" key={g.text || g[0].text}>
            <>
                <Commands commands={g.commands} exec={getExecutable(g)} />
                {(g != lastGroup) ? <li className="divider"></li> : null}
            </>
        </ul>
    ))

}

const Submenu: React.FunctionComponent<{ commands: IOmniaCommand[], exec: Executable }> = ({ commands, exec }) => {

    if (isArrayEmpty(commands)) return null

    return (

        <li className="dropdown-submenu">
            <a tabIndex={-1}>
                <i className="icon icon-option-vertical"></i>&nbsp;More
            </a>
            <ul className="dropdown-menu">
                <Commands {...{ commands, exec }} />
            </ul>
        </li >

    )

}

const Commands: React.FunctionComponent<{ commands: IOmniaCommand[], exec: Executable }> = ({ commands, exec }) => {

    if (isArrayEmpty(commands)) return null

    return (
        <>
            {
                commands.map(c => (
                    <li key={c.text} className={`${exec.check(c) ? null : 'disabled'}`}>
                        <a onClick={e => exec.run(c)}>
                            <i className={getIconClass(c.icon)}></i>&nbsp;{c.text}
                        </a>
                    </li >
                ))
            }
        </>
    )

}

function getExecutable(group: IOmniaCommandGroup) {

    function call(command: IOmniaCommand, getHandler: (c: IOmniaCommand) => Function) {
        const handler = getHandler(command)
        if (!omnia.isFunction(handler)) return true
        return handler.apply(command, [group.datacontext])
    }

    function check(command: IOmniaCommand) {
        return call(command, c => c.canExecute)
    }

    function run(command: IOmniaCommand) {
        if (check(command)) {
            return call(command, c => c.execute)
        }
    }

    return {
        check,
        run,
    }

}
